import script from "./LogoffView.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoffView.vue?vue&type=script&setup=true&lang=js"

import "./LogoffView.vue?vue&type=style&index=0&id=cd4bd496&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd4bd496"]])

export default __exports__